import _ from 'lodash'
import React, { useEffect } from 'react'
import Chart from 'chart.js/auto'
import apiService from 'apiService'

function CardBarDailySales({ storeId, startDate, endDate, update }) {
    const getDailySales = async () => {
        if (window.barDailySales) window.barDailySales.destroy()

        const config = {
            type: 'bar',
            data: {
                labels: [],
                datasets: [
                    {
                        label: 'Αρχικό',
                        backgroundColor: '#ef4444',
                        borderColor: '#ef4444',
                        data: [],
                        fill: false,
                        barThickness: 8
                    },
                    {
                        label: 'Τελικό',
                        fill: false,
                        backgroundColor: '#10b981',
                        borderColor: '#10b981',
                        data: [],
                        barThickness: 8
                    },
                    {
                        label: 'Ωφέλιμο',
                        fill: false,
                        backgroundColor: '#7FFFD4',
                        borderColor: '#7FFFD4',
                        data: [],
                        barThickness: 8
                    },
                    {
                        label: 'Επαναλήψεις',
                        fill: false,
                        backgroundColor: '#FF7F50',
                        borderColor: '#FF7F50',
                        data: [],
                        barThickness: 8
                    },
                    {
                        label: 'Απευθείας',
                        fill: false,
                        backgroundColor: '#8B0000',
                        borderColor: '#8B0000',
                        data: [],
                        barThickness: 8
                    },

                    {
                        label: 'Ποσοστό',
                        fill: false,
                        backgroundColor: 'rgba(2, 132, 199)',
                        borderColor: 'rgba(2, 132, 199)',
                        data: [],
                        barThickness: 0
                    }
                ]
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,
                interaction: {
                    mode: 'index'
                }
            }
        }
        const payload = {
            startDate: startDate,
            endDate: endDate
        }
        const results = await apiService.post(`/stats/store/${storeId}/daily-sales`, payload)
        if (!results) return

        const labels = results.map(el => el.date)
        const initial = results.map(el => _.round(el.initial, 2))
        const final = results.map(el => _.round(el.final, 2))
        const directed = results.map(el => _.round(el.directed, 2))
        const reprinted = results.map(el => _.round(el.reprinted, 2))
        const winning = results.map(el => _.round(el.winning, 2))
        const percentage = results.map(el => _.round(el.percentage, 2))
        config.data.labels = labels
        _.set(config, 'data.datasets[0].data', initial)
        _.set(config, 'data.datasets[1].data', final)
        _.set(config, 'data.datasets[2].data', winning)
        _.set(config, 'data.datasets[3].data', reprinted)
        _.set(config, 'data.datasets[4].data', directed)
        _.set(config, 'data.datasets[5].data', percentage)
        let ctx = document.getElementById('bar-chart-daily-sales').getContext('2d')
        window.barDailySales = new Chart(ctx, config)
    }

    useEffect(() => {
        if (!storeId) return
        getDailySales()
    }, [update])
    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full max-w-full flex-grow flex-1">
                            <h2 className="text-blueGray-700 text-xl font-semibold">Στατιστικά ανά ημέρα</h2>
                        </div>
                    </div>
                </div>
                <div className="p-4 flex-auto">
                    <div className="relative h-350-px">
                        <canvas id="bar-chart-daily-sales"></canvas>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardBarDailySales
